<!--
@Create By Tim For 19/08/16
@讲师介绍组件
-->
<template>
  <div class="LecturerInfo">
    <div class="title">讲师介绍</div>

    <div class="personalDetails">
      <div class="personalDetailsImg">
        <!-- <el-image :src="avatar"> -->
        <el-image :src="require('../../../static/image/user.jpg')">
          <div slot="error"><img :src="require('../../../static/image/user.jpg')" /></div>
        </el-image>
      </div>
      <samp>{{ userName }}</samp>
    </div>

    <div class="ql-container ql-snow"><div class="ql-editor" v-html="description"></div></div>
  </div>
</template>

<script>
import api from '../../../config/api';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  name: 'LecturerInfo',
  data() {
    return {
      id: null,
      userName: null,
      avatar: null,
      description: null
      //errorImg01: `${process.env.VUE_APP_SSO_HOST_URL}static/avatar/profile/1.jpg`,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.getLecturer(this.id);
  },
  methods: {
    getLecturer(id) {
      this.$axios.get(api + `portal/teacher/course/${id}`).then(res => {
        if (res) {
          this.userName = res.userName;
          this.avatar = res.avatar;
          this.description = res.description;
        }
      });
    }
  }
};
</script>

<style scoped>
.LecturerInfo .title {
  font-size: 16px;
  color: #333;
  margin-bottom: 30px;
}

.LecturerInfo .personalDetails {
  height: 60px;
  font-size: 16px;
  color: #333;
}

.LecturerInfo .personalDetailsImg {
  float: left;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background: #ccc;
  margin-right: 30px;
  overflow: hidden;
}

.LecturerInfo .personalDetailsImg img {
  width: 60px;
  height: 60px;
}

.LecturerInfo p {
  font-size: 14px;
  color: #333;
  line-height: 25px;
  margin-top: 40px;
}
.ql-container.ql-snow {
  border: 0px solid #ccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseInfo/LecturerInfo.vue